export default {
    type: 'news-and-views',
    name: 'News and Views',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleNewsAndViews',
            loader: () => import('./ModuleNewsAndViews')
        }
    }
};
